export const Card = {
  transclude: {
    badges: '?badges',
    left: '?footerLeft',
    right: '?footerRight',
  },

  bindings: {
    heading: '<',
    description: '<',
    isFavourite: '<',
    img: '<',
    cardClass: '<',
    onFavourite: '&',
    onClick: '&',
  },

  template: `
    <div class="card card-voome card-borderless" ng-class="$ctrl.cardClass">
      <favourite-button
        is-favourite="$ctrl.isFavourite"
        ng-click="$ctrl.onFavourite()"
        ng-if="$ctrl.isFavourite !== undefined">
      </favourite-button>
      <div class="card-img-wrapper" ng-click="$ctrl.onClick()">
        <image-background src="$ctrl.img">
          <div class="card-badge-wrapper" ng-transclude="badges"></div>
        </image-background>
      </div>
      <div class="card-block card-title mb-0 d-flex justify-content-center align-items-center"
        ng-if="$ctrl.heading"
        ng-click="$ctrl.onClick()">
        <span class="title word-wrap">{{ $ctrl.heading }}</span>
      </div>
      <div class="card-footer"
        ng-click="$ctrl.onClick()">
        <div class="card-footer-left" ng-transclude="left"></div>
        <div class="card-footer-right" ng-transclude="right"></div>
      </div>
    </div>
    <div class="card-description my-3"
      ng-if="$ctrl.description"
      ng-bind-html="$ctrl.description">
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Card/Card.js